<app-modal
  [autoClose]="autoClose"
  [hasCloseButton]="hasCloseButton"
  [role]="alertRole"
  (modalClose)="closeModal()"
  class="alert-modal"
>
  <div modal-header><ng-content select="[modal-header]"></ng-content></div>
  <div modal-content><ng-content select="[modal-content]"></ng-content></div>
  <div modal-footer class="alert-modal__footer">
    <button
      *ngIf="hasCloseButton"
      app-vtmn-play-button
      type="button"
      class="alert-modal__footer__close"
      [variant]="variantButtonClose"
      [shape]="vtmnPlayButtonShape.SQUARED"
      (click)="closeModal()"
    >
      {{ closeLabel }}
    </button>
    <button
      app-vtmn-play-button
      type="button"
      class="alert-modal__footer__confirm"
      [variant]="variantButtonConfirm"
      (click)="confirmModal()"
      [disabled]="disabledConfirmButton ? true : null"
      [attr.data-disabled]="disabledConfirmButton ? true : null"
      [shape]="vtmnPlayButtonShape.SQUARED"
    >
      {{ confirmLabel }}
    </button>
  </div>
</app-modal>
